import { useEffect } from 'react';
import { useAppStore } from '../store/useAppStore';

/** Wendet den gewählten Theme-Modus auf das Wurzelelement an (FR-THEME-001/002). */
export function useAppliedTheme(): void {
  const theme = useAppStore((state) => state.theme);

  useEffect(() => {
    const root = document.documentElement;

    function applySystemPreference(): void {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      root.dataset.theme = prefersDark ? 'dark' : 'light';
    }

    if (theme === 'system') {
      applySystemPreference();
      const media = window.matchMedia('(prefers-color-scheme: dark)');
      media.addEventListener('change', applySystemPreference);
      return () => media.removeEventListener('change', applySystemPreference);
    }

    root.dataset.theme = theme;
    return undefined;
  }, [theme]);
}
